import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware, compose } from 'redux';
import { flashMiddleware } from 'mui-redux-flash';
import thunkMiddleware from 'redux-thunk';
import createRootReducer from '../reducers';

// Middleware to add products/cart to router action. Primarily as a hack for Tesco analytics integration
const locationStateMiddleware = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    action.payload.products = store.getState().product.products;
    action.payload.cart = store.getState().cart.cart;
  }
  next(action);
}

export const history = createBrowserHistory({basename: window.BASE_PATH});
const middlewares = [routerMiddleware(history), flashMiddleware({timeout: 6000}), thunkMiddleware, locationStateMiddleware];

// Enables the Redux DevTools extension to Chrome & Firefox
// See https://github.com/zalmoxisus/redux-devtools-extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  createRootReducer(history),
  composeEnhancers(
    applyMiddleware(
      ...middlewares
    )
  )
);

export default store;
